import * as React from "react";
import * as ReactDOM from "react-dom";
import ProviderSearch from "./ProviderSearch";
import { BrowserRouter as Router, Route } from "react-router-dom";

ReactDOM.render(
  <Router>
	<React.Fragment>
		<Route path="/search/providers/:tag?" component={ProviderSearch} />
	</React.Fragment>
  </Router>,
  document.getElementById("search")
);
